import { render, staticRenderFns } from "./ProductImage.vue?vue&type=template&id=06451746&scoped=true&"
import script from "./ProductImage.vue?vue&type=script&lang=js&"
export * from "./ProductImage.vue?vue&type=script&lang=js&"
import style0 from "./ProductImage.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./ProductImage.vue?vue&type=style&index=1&id=06451746&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06451746",
  null
  
)

export default component.exports